import defaultSettings from '@/settings'

const title = defaultSettings.title || '八狐云'

export default function getPageTitle(pageTitle) {
  if (pageTitle) {
    return `${pageTitle} - ${title}`
  }
  return `${title}`
}
